import { useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";

type Props = {
    state: string;
    setState: (value: string) => void;
    zip: string;
    setZip: (value: string) => void;
}

export const TextSettings = ({ state, setState, zip, setZip }: Props) => {
    const { themeStyles } = useTheme();
    const [disabled, setDisabled] = useState<boolean>(true);

    return (
        <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
            <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                <div className="w-full mt-2">
                    <div className={`w-full pb-4`}>
                        <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                            <div className="flex items-center gap-1.5">
                                <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Text Settings</h2>
                            </div>

                            {
                                disabled && (
                                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                        onClick={() => setDisabled(false)}
                                    >
                                        <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                            edit
                                        </span>
                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                    </button>
                                )
                            }
                        </div>

                        <div className="grid grid-cols-3 gap-6">
                            <div className="space-y-4">
                                <div>
                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>State</label>
                                    <input
                                        type="text"
                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                        value={state}
                                        onChange={(e) =>
                                            setState(e.target.value)
                                        }
                                        disabled={disabled}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Zip</label>
                                    <input
                                        type="text"
                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                        value={zip}
                                        inputMode="numeric"
                                        onChange={(e) =>
                                            setZip(e.target.value.replace(/\D/g, ""))
                                        }
                                        disabled={disabled}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
